import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { StyledButton, BrainLoader } from '../../../../Components/Generics.styled';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import CircularProgress from '@mui/material/CircularProgress';
import { useProfile } from '../../../../Contexts/UserProfileContext';

const CampaignStrategyContainer = styled.div`
    min-width: 1200px;
    min-height: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled.div`
    margin-top: 50px;
    text-align: center;
    font-size: 36px;
    font-weight: 400;
`;

const CampaignStrategyContent = styled.div`
    margin-top: 30px;
    border: 1px solid black;
    min-width: 1200px;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
`;

const Column1 = styled.div`
    min-width: 70%;
    border-right: 1px solid black;
    min-height: 600px;
`;

const Column2 = styled.div`
    min-width: 30%;
    padding: 24px;
`;

const SideButtonsContainer = styled.div`
    border-bottom: 1px solid black;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 200px;
    margin-bottom: 40px;
`;
const Header = styled.div`
    text-align: center;
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 20px;
    min-width: 240px;
`;

const CampStratBtn = styled(StyledButton)`
    font-size: 23px;
    width: 100%;
    max-width: unset;
    max-height: unset;
`;

const StrategySection = styled.div`
    border-bottom: 1px solid black;
    min-height: 200px;
    padding-bottom: 50px;
    padding: 24px;
    max-width: 800px;
`;

const SideButton = ({ header, btnLabel, onClick, disabled }) => {
    return (
        <SideButtonsContainer>
            <Header>{header}</Header>
            <CampStratBtn disabled={disabled} onClick={onClick}>
                {btnLabel}
            </CampStratBtn>
        </SideButtonsContainer>
    );
};

SideButton.propTypes = {
    header: propTypes.string,
    btnLabel: propTypes.oneOfType([(propTypes.string, propTypes.node)]),
    onClick: propTypes.func,
    disabled: propTypes.bool,
};

SideButton.defaultProps = {
    header: 'header',
    btnLabel: 'button label',
    onClick: () => {},
    disabled: false,
};
const ConnectedCampaignStrategy = ({ teachDavieData }) => {
    const history = useHistory();
    const { profile } = useProfile();

    const [pdfGeneratorData, setPdfGeneratorData] = useState({
        isLoading: false,
        error: false,
        success: false,
        message: [''],
    });
    const [chatGPTData, setChatGPTData] = useState({});

    const [gptPostData, setGPTPostData] = useState({
        isLoading: false,
        error: false,
        success: false,
        message: [''],
    });

    const gptIsLoading = gptPostData?.isLoading || !teachDavieData;

    const fetchTheData = async () => {
        try {
            setGPTPostData({ ...gptPostData, isLoading: true });

            const chatGPTResp = await axios({
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/generateCampaignStrategy`,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {
                    teachDavieData
                },
            });

            const strategyData = chatGPTResp?.data;

            if (strategyData && strategyData.campaignName && strategyData.adFormat) {
                setChatGPTData(strategyData);
                setGPTPostData({
                    isLoading: false,
                    success: true,
                    error: false,
                    message: ['Successful'],
                });
            } else {
                console.error('Invalid response structure:', strategyData);
                setGPTPostData({
                    isLoading: false,
                    success: false,
                    error: true,
                    message: ['Invalid response from server'],
                });
            }
        } catch (err) {
            setGPTPostData({
                isLoading: false,
                success: false,
                error: true,
                message: ['Something went wrong'],
            });
        }
    };

    useEffect(() => {
        if (teachDavieData) {
            fetchTheData();
        }
    }, [teachDavieData]);

    const campaignStrategySection = (
        <Column1>
            {gptIsLoading ? (
                <BrainLoader label="We're thinking about it... " />
            ) : (
                <>
                    <StrategySection>
                        <div style={{ fontSize: '23px', fontWeight: 600 }}>Suggested overall monthly marketing budget: ${teachDavieData?.budget}</div>

                        <div style={{ fontSize: '20px', fontWeight: 600, marginTop: '10px' }}>
                            <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>Campaign Name:</div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.campaignName?.googlePaidSearch}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.campaignName?.programmatic}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Mobile: </span>
                                {chatGPTData?.campaignName?.mobile}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.campaignName?.display}
                            </div>
                        </div>

                        <div style={{ fontSize: '20px', fontWeight: 600, marginTop: '10px' }}>
                            <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>Ad Format:</div>{' '}
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.adFormat?.googlePaidSearch}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.adFormat?.programmatic}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                {' '}
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.adFormat?.mobile}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.adFormat?.display}
                            </div>
                        </div>

                        <div style={{ fontSize: '20px', fontWeight: 600, marginTop: '10px' }}>
                            <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>Target Audience:</div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.targetAudience?.googlePaidSearch}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.targetAudience?.programmatic}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.targetAudience?.mobile}
                            </div>
                            <div style={{ fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.targetAudience?.display}
                            </div>
                        </div>
                    </StrategySection>
                    <StrategySection>
                        <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>
                            Targeting:{' '}
                            <div style={{ fontSize: '20px', fontWeight: 300, marginTop: '10px' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.targetingSection?.googlePaidSearch}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: 300, marginTop: '10px' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.targetingSection?.programmatic}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: 300, marginTop: '10px' }}>
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.targetingSection?.mobile}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: 300, marginTop: '10px' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.targetingSection?.display}
                            </div>
                        </div>
                    </StrategySection>
                    <StrategySection>
                        <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>
                            Ad Script:{' '}
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.adScript?.googlePaidSearch}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.adScript?.programmatic}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.adScript?.mobile}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.adScript?.display}
                            </div>
                        </div>
                    </StrategySection>
                    <StrategySection>
                        <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>
                            Ad Extensions:{' '}
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.adExtensions?.googlePaidSearch}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.adExtensions?.programmatic}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.adExtensions?.mobile}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.adExtensions?.display}
                            </div>
                        </div>
                    </StrategySection>
                    <StrategySection style={{ borderBottom: 'unset' }}>
                        <div style={{ fontSize: '28px', fontWeight: 600, marginTop: '10px' }}>
                            Budget:
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Google Paid Search:</span> {chatGPTData?.budgetSection?.googlePaidSearch}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Programmatic:</span> {chatGPTData?.budgetSection?.programmatic}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}> Mobile:</span> {chatGPTData?.budgetSection?.mobile}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '300' }}>
                                <span style={{ fontWeight: 'bold' }}>Display:</span> {chatGPTData?.budgetSection?.display}
                            </div>
                        </div>
                    </StrategySection>
                </>
            )}
        </Column1>
    );

    const html = ReactDOMServer.renderToStaticMarkup(campaignStrategySection);

    const generatePDF = async () => {
        setPdfGeneratorData({ ...pdfGeneratorData, isLoading: true });
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/pdfGenerator`,
                {
                    html,
                },
                {
                    responseType: 'blob', // tell axios to treat response as a binary blob
                }
            );
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${profile.firstName}_${profile.lastName}_Campaign_Strategy.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            setPdfGeneratorData({
                ...pdfGeneratorData,
                isLoading: false,
                error: true,
                success: false,
                message: 'Something went wrong',
            });
        }
        setPdfGeneratorData({
            ...pdfGeneratorData,
            isLoading: false,
            error: false,
            success: true,
            message: 'PDF Generated Successfully',
        });
    };

    return (
        <CampaignStrategyContainer>
            <Title>
                Your <span style={{ color: '#2e69fd', fontWeight: '600' }}>davie.ai</span> Campaign Strategy!
            </Title>
            <CampaignStrategyContent>
                {campaignStrategySection}

                <Column2>
                    <SideButton
                        header="Download your Campaign Strategy"
                        disabled={gptIsLoading}
                        btnLabel={
                            pdfGeneratorData.isLoading ? (
                                <CircularProgress
                                    style={{
                                        height: '20px',
                                        width: '20px',
                                        color: 'white',
                                    }}
                                    color="primary"
                                />
                            ) : (
                                'Download PDF'
                            )
                        }
                        onClick={() => {
                            generatePDF();
                        }}
                    />
                    <SideButton
                        header="Start a Campaign!"
                        btnLabel="Click to Start"
                        onClick={() => {
                            history.push('/portal/campaign/createACampaign');
                        }}
                    />
                    <SideButton
                        header="Go to your Dashboard"
                        btnLabel="Dashboard"
                        onClick={() => {
                            history.push('/portal/dashboard');
                        }}
                    />
                </Column2>
            </CampaignStrategyContent>
        </CampaignStrategyContainer>
    );
};

ConnectedCampaignStrategy.propTypes = {
    teachDavieData: propTypes.shape({
        budget: propTypes.number,
        hasCompletedData: propTypes.bool,
    }),
};

ConnectedCampaignStrategy.defaultProps = {
    teachDavieData: {},
};

export default ConnectedCampaignStrategy;
